import React from "react";
import {
  TableHeader as Header,
  TableRow as Row,
  TableHeaderCell as HeaderCell,
} from "semantic-ui-react";

const TableHeader = (props) => {
  return (
    <Header>
      <Row>
        {props.header.map((cell, index) => (
          <HeaderCell key={index}>{cell}</HeaderCell>
        ))}
      </Row>
    </Header>
  );
};

export default TableHeader;
